import { phoneNumber } from '#base/core/consts/companyData';
import type { UrlType } from '#base/core/types/UrlType';

export const phoneLink: UrlType = {
	title: 'Bel ons',
	url: `tel:${phoneNumber}`,
};

export const homeLink: UrlType = {
	title: 'Homepage',
	url: '/',
};

export const fysioLink: UrlType = {
	title: 'Fysio Hier homepage',
	url: 'https://fysiohier.com/',
};

export const fitLink: UrlType = {
	title: 'Fit Hier homepage',
	url: 'https://fithier.com/',
};
